import React from 'react';

import { Button, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { grey } from '@material-ui/core/colors';
import { colors } from '../config/theme';

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    backgroundColor: `${grey[300]}`,
    fontWeight: 600,
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
    marginRight: theme.spacing(1),
  },
  primary: {
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.primary.light,
    '&:hover': {
      backgroundColor: colors.whiteIce,
    },
  },
  dangerous: {
    backgroundColor: colors.softPeachDark,
    '&:hover': {
      backgroundColor: colors.softPeach,
    },
  },
  default: {
    backgroundColor: colors.gallery,
    '&:hover': {
      backgroundColor: colors.alto,
    },
  },
}));

interface InlineButtonProps {
  children: React.ReactNode;
  type?: 'primary' | 'dangerous' | 'default';
  onClick: () => void;
  disabled?: boolean;
}

const InlineButton = (props: InlineButtonProps) => {
  const { children, type, onClick, disabled = false } = props;

  const classes = useStyles();

  let additionalClassName = '';
  if (type !== undefined) {
    additionalClassName = classes[type];
  }

  return (
    <Button
      className={`${classes.button} ${additionalClassName}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default InlineButton;
